export const types = {
    GENERAL: 'General'
};